var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("merge-invoice-file-checking-dialog", {
        attrs: {
          visible: _vm.checkingDialog.visible,
          "row-data": _vm.checkingDialog.rowData,
          "show-next": _vm.checkingDialog.showNext
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.checkingDialog, "visible", $event)
          },
          next: _vm.continueHandle
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }